// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"style_BackButton__ludz7","text":"style_text__1riK6"};